import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from "@src/routes/routes";
import './styles/App.scss';
import store from './store/store';
import { Provider } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LanguageProvider } from './context/LanguageContext';
import { COUNTRY_CODE } from "@src/config/constant";

function App() {
    // Effect to dynamically update the favicon based on COUNTRY_CODE
    useEffect(() => {

        const faviconFile = COUNTRY_CODE === 'id' ? 'favicon_id.ico' : 'favicon.ico';
        const faviconUrl = `${process.env.PUBLIC_URL}/${faviconFile}`;

        let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }

        link.type = 'image/x-icon';
        link.href = faviconUrl;
    }, []);


    return (
        <div className="App">
            <LanguageProvider>
                <Provider store={store}>
                    <BrowserRouter>
                        <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={5000} icon={false}/>
                        <AppRoutes />
                    </BrowserRouter>
                </Provider>
            </LanguageProvider>
        </div>


    );
}

export default App;
